import { TicketPriority } from "@copetence/shared";
import { classes } from "handlers/StyleHandler";
import s from "./priorityIndicator.module.scss";

export const PriorityIndicator = ({
  priority,
  onAccent = false,
}: {
  onAccent?: boolean;
  priority: TicketPriority;
}) => {
  return (
    <div className={classes(s.indicator, onAccent ? s.onAccent : "")}>
      {priority === TicketPriority.URGENT ? (
        <div className={s.urgentBox}>!</div>
      ) : (
        <>
          <div className={classes(s.indicatorBar, s.active)} />
          <div
            className={classes(
              s.indicatorBar,
              priority === TicketPriority.MEDIUM ? s.active : "",
              priority === TicketPriority.HIGH ? s.active : ""
            )}
          />
          <div
            className={classes(
              s.indicatorBar,
              priority === TicketPriority.HIGH ? s.active : ""
            )}
          />
        </>
      )}
    </div>
  );
};
